import { render } from "./ParcoursDisciplesPage.vue?vue&type=template&id=62b050b5"
import script from "./ParcoursDisciplesPage.vue?vue&type=script&lang=js"
export * from "./ParcoursDisciplesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__